import React, { useContext } from "react";
import { QbPaymentContext } from "../../../../contexts/QbPaymentContext";
import OwLabel from "../../OwLabel/OwLabel";
import IOrder from "../../../../models/IOrder";
import HelperService from "../../../../services/HelperService";
import SupplierContext from "../../../../contexts/SupplierContext";

type Props = {
    orderModel: IOrder;
};

export const QuickBooksPaymentProcessingDetail = (props: Props) => {
    const supplierModel = useContext(SupplierContext);
    const qbPaymentContext = useContext(QbPaymentContext);

    return (
        <div className={"QuickBooksPaymentProcessingDetail"}>
            <div>
                <OwLabel title={"sub_total"} postText={":"} className={"me-2"} />
                {HelperService.formatCurrency({
                    value: props.orderModel.sub_total,
                    precision: supplierModel.pricing_precision || 2,
                })}
            </div>
        </div>
    );
};
